import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { ModalOrDrawerBodyWithMask } from '@ui/components/ModalOrDrawer';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { getNftTokens } from '@ui/queries/sdk';
import { currentWallet } from '@veno-app/wallet';
import { useMemo } from 'react';

import { BatchCard } from './BatchCard';

export const DefaultContent = () => {
  const t = useTranslations();
  const coinMode = useCoinMode();
  const sdk = useVenoSDK();
  const account = currentWallet.useAccount();

  const nftsRet = useQuery({
    ...getNftTokens({
      coinMode,
      sdk,
      owner: account ?? '',
    }),
  });

  const nfts = useMemo(() => {
    /**
     * sort the list in descending order so the latest NFT is always on top
     */
    return nftsRet.data
      ? [...nftsRet.data].sort((a, b) => (b.id.gt(a.id) ? 1 : -1))
      : [];
  }, [nftsRet.data]);

  return (
    <ModalOrDrawerBodyWithMask maskHeight={60} pt="0">
      {!!nfts?.length && (
        <Text color="text-light" textAlign="center" mb="16px">
          {t('pending-batches-hint')}
        </Text>
      )}
      {nftsRet.isLoading && <Skeleton h="200px" />}
      {!nftsRet.isLoading && !nfts?.length && (
        <Flex height="200px" alignItems="center" justifyContent="center">
          <Text color="text-light" textAlign="center">
            {t('You have no pending receipts')}
          </Text>
        </Flex>
      )}
      {(nfts ?? []).map((nft, i) => {
        return <BatchCard key={i} nft={nft} />;
      })}
    </ModalOrDrawerBodyWithMask>
  );
};
